import { Box, Theme, Typography, useMediaQuery } from "@mui/material";
import {
  Datagrid,
  RichTextField,
  TextField,
  useRecordContext,
} from "react-admin";
import ApplicationLinkField from "../applications/ApplicationLinkField";
import CustomAmountField from "../unit/CustomAmountField";
import CustomDateField from "../unit/CustomDateField";
import LoanNumLinkField from "./LoanNumLinkField";
import { hmLightTheme } from "../themes/hmTheme";
const CustomAttentionField = ({ ...props }) => {
  const record = useRecordContext();
  if (record == null) {
    return null;
  }
  const transferFailedNumber = record.iTransferFailedNumber;
  const insufficientBalanceCheckNumber = record.iInsufficientBalanceCheckNumber;
  const transferFatalErrorNumber = record.iTransferFatalErrorNumber;

  let textcolor = "textSecondary";

  let errorValue = [];
  if (transferFailedNumber >= 2) {
    errorValue.push("Transfer Failed");
  }
  if (insufficientBalanceCheckNumber >= 2) {
    errorValue.push("Insufficient Balance");
  }
  if (transferFatalErrorNumber >= 1) {
    errorValue.push("Funding Source Removed");
  }
  return (
    <Typography variant="body2" sx={{ mb: 1, color: "black" }}>
      {errorValue.map((item, index) => (
        <span key={index}>
          <br />
          {item}
        </span>
      ))}
    </Typography>
  );
};
const CustomerLoanUserNameAndCoAppNameField = ({ ...props }) => {
  const record = useRecordContext();
  if (record == null) {
    return null;
  }
  return (
    <>
      <Box>
        {record.sFirstName} {record.sLastName} <br />
        {record.coapplication_name}
      </Box>
    </>
  );
};

const DefaultLoanList = ({ ...props }) => {
  const filterStatus = props?.filterStatus;
  const curStatus = props?.curStatus;
  const currentUrl = window.location.href;
  const urlWithoutDomain = currentUrl.replace(window.location.origin, "");
  const isXsmall = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down("sm")
  );
  const isSmall = useMediaQuery<Theme>((theme) => theme.breakpoints.down("md"));
  const sort = { field: "id", order: "DESC" };
  return (
    <>
      <Datagrid
        optimized
        rowClick={false}
        stickyHeader={true}
        size="small"
        id="table-loans"
        className="hm-list-datagrid"
        empty={false}
        sx={{
          ".MuiTableCell-root": {
            padding: "6px",
          },
          ".RaDatagrid-headerCell:first-child": {
            borderTopLeftRadius: "0px",
          },
          ".RaDatagrid-headerCell:last-child": {
            borderTopRightRadius: "0px",
          },
          "& .column-groups": {
            md: { display: "none" },
            lg: { display: "table-cell" },
          },
          "& .Mui-active": {
            color: "gray",
          },
          "& .MuiTableSortLabel-root": {
            padding: "5px",
          },
          "& .RaDatagrid-headerCell": {
            color: "gray",
            fontSize: "1rem",
            backgroundColor: "#edf4fb",
            wordWrap: "break-word",
          },
          "& .MuiTableCell-paddingCheckbox": {
            display: "none",
          },
          "& .MuiTableCell-root.column-sProductName": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-dNoteDate": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
          },
          "& .MuiTableCell-root.column-dMaturityDate": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
          },
          "& .MuiTableCell-root.column-sOriginalNoteAmount": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            textAlign: "right",
          },
          "& .MuiTableCell-root.column-sActivePrincipalBalance": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            textAlign: "right",
          },
          "& .MuiTableCell-root.column-sAmountChargedOff": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            textAlign: "right",
          },
          "& .MuiTableCell-root.column-sPaymentFrequency ": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
          },
          "& .MuiTableCell-root.column-curStatus": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdSmallWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdSmallWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdSmallWidth,
          },
          "& .MuiTableCell-root.column-attention": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
          },
          "& .MuiTableCell-root.column-sComment": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },

          "& .MuiTableCell-root.column-updated_status_at ": {
            minWidth: "110px",
            width: "110px",
            maxWidth: "110px",
          },

          "& .MuiTableCell-root.column-iApplicationId": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
          },
          "& .MuiTableCell-root.column-sLoanNum": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
          },
          "& .MuiTableCell-root.column-iUserId": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
          },
          "& .MuiTableCell-root.column-userName": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
        }}
      >
        {/* <TextField source="sLoanNum" label="Loan #" />   */}
        <LoanNumLinkField
          label="Loan #"
          sortBy="loannum"
          source="loannum"
          backUrl={urlWithoutDomain}
        />
        <TextField source="sProductName" label="Product" sortBy="product" />
        <CustomerLoanUserNameAndCoAppNameField
          source="userName"
          label="Borrower Name"
          sortable={true}
          sortBy="userName"
        />

        <CustomDateField
          source="dNoteDate"
          label="Note Date"
          onlyShowDate={true}
          sortBy="notedate"
          cellClassName="dateText"
        />
        <CustomDateField
          source="dMaturityDate"
          label="Maturity Date"
          onlyShowDate={true}
          sortBy="maturitydate"
          cellClassName="dateText"
        />
        {/* <CustomAmountField source="sOriginalNoteAmount" label="Note Amount" /> */}
        <CustomAmountField
          source="sOriginalNoteAmount"
          label="Original Principal Amount"
          sortBy="originalnoteamount"
          cellClassName="amountText"
        />
        {filterStatus != "Charged-Off" && filterStatus != "Voided" && (
          <CustomAmountField
            source="sActivePrincipalBalance"
            label="Remaining Principal Amount"
            sortBy="activeprincipalbalance"
            cellClassName="amountText"
          />
        )}

        {filterStatus != "Voided" && (
          <TextField
            source="sPaymentFrequency"
            label="Payment Frequency"
            sortBy="paymentfrequency"
          />
        )}

        {filterStatus != "Voided" && (
          <CustomDateField
            source="dLastPaymentDate"
            label="Last Payment Date"
            sortBy="lastpaymentdate"
            onlyShowDate={true}
            cellClassName="dateText"
          />
        )}

        {/* “Status” for Active, Paid-Off; “Charged-Off Amount” for Charged-Off, “Voided Reason” for Voided */}
        {filterStatus == "active" &&
          (curStatus == "Funding Source Removed" ||
            curStatus == "Insufficient Balance" ||
            curStatus == "Transfer Failed") && (
            <TextField source="curStatus" label="Status" sortBy="curStatus" />
          )}
        {filterStatus == "Charged-Off" && (
          <CustomAmountField
            source="sAmountChargedOff"
            label="Charged-Off Amount"
            sortBy="chargedoffamount"
            cellClassName="amountText"
          />
        )}
        {filterStatus == "Voided" && (
          <RichTextField
            // source="sComment"
            source="sComment_notes"
            label="Voided Reason"
            sortBy="sComment_notes"
          />
        )}
        {/* “Attention” for Active, “Date Paid Off” for Paid Off,  “Date Charged Off” for Charged Off, “Date Voided” for Voided */}
        {filterStatus == "active" &&
          curStatus != "Transfer Failed" &&
          curStatus != "Insufficient Balance" &&
          curStatus != "Funding Source Removed" && (
            <CustomAttentionField label="Attention" />
          )}

        {filterStatus == "Paid-Off" && (
          <CustomDateField
            source="updated_status_at"
            label="Date Paid Off"
            onlyShowDate={true}
            sortBy="updateat"
            cellClassName="dateText"
          />
        )}
        {filterStatus == "Charged-Off" && (
          <CustomDateField
            source="updated_status_at"
            label="Date Charged Off"
            onlyShowDate={true}
            sortBy="updateat"
            cellClassName="dateText"
          />
        )}
        {filterStatus == "Voided" && (
          <CustomDateField
            source="updated_status_at"
            label="Date Voided"
            onlyShowDate={true}
            sortBy="updateat"
            cellClassName="dateText"
          />
        )}
        {/* “Reset History” for Active, Paid-Off, Charged-Off, “Voided by” for Voided */}
        {filterStatus == "Voided" ? (
          <TextField source="sOper" label="Voided by" sortable={false} />
        ) : (
          <TextField
            source="allModifyNum"
            label="Reset History"
            sortBy="allModifyNum"
            cellClassName="numericText"
          />
        )}
        {/* <TextField source="curStatus" label="Status" sortBy="status" /> */}
        {/* <TextField source="updated_at" label="Last Modified" /> */}
        {/* <TextField
          source="iApplicationId"
          label="App #"
          sortBy="id"
          sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
        /> */}
        <ApplicationLinkField
          source="iApplicationId"
          label="App #"
          sortBy="id"
        />
        {localStorage.getItem("authrole") == "admin" && (
          <TextField source="sBank" label="Institution" sortBy="sBank" />
        )}
      </Datagrid>
    </>
  );
};

export default DefaultLoanList;
